import { Illustration, Text, Button, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Box, Spinner } from 'native-base';
import React from 'react';

import { FileField } from '../../../RateManagement/Upload/components/FileField';
import { useSpreadsheetImport } from '../../hooks/spreadsheet-import';

interface SpreadsheetImportProps {}

export const SpreadsheetImport: React.FC<SpreadsheetImportProps> = () => {
  const {
    handleReset,
    handleError,
    handleFileChange,
    handleImport,
    importButtonIsDisabled,
    isImportingSpreadsheet,
  } = useSpreadsheetImport();
  return (
    <VStack alignItems="center" justifyContent="center" space={Spacing['stack.xxs']} w="full">
      <Illustration name="SpreadsheetIllustration" />
      <VStack space={Spacing['stack.nano']} alignItems="center" justifyContent="center">
        <Text>
          Precisamos que você anexe a<Text fontWeight="semibold">{' planilha base '}</Text>
          preenchida.
        </Text>
        <Text textAlign="center" color="neutral.black" fontSize={Typography['fontsize.xs']}>
          Lembre-se de preencher a planilha corretamente.
        </Text>
      </VStack>
      <Box w="full">
        <FileField onReset={handleReset} onError={handleError} onSelectFile={handleFileChange} />
      </Box>
      <Button
        w="full"
        isDisabled={importButtonIsDisabled}
        onPress={handleImport}
        _text={{ fontWeight: Typography['fontweight.semibold'] }}
        {...(isImportingSpreadsheet && {
          endIcon: <Spinner size="sm" color={Color['neutral.white']} />,
        })}>
        {isImportingSpreadsheet ? 'Importando...' : 'Importar'}
      </Button>
    </VStack>
  );
};
